<template>
  <div class="editInfos-match-container">
    <div class="editInfos-match-head">
      <van-nav-bar
        title="编辑资料"
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      />
      <div class="content-photo">
        <div @click="previewAvatar">
          <img
            class="editInfo-Photo"
            :src="avatarLink || defaultPhoto"
            alt=""
          />
        </div>
        <div>
          <!-- <span>2021.03.28 14:23:43由 张超 更新</span> -->
          <span>建议使用本人真实1:1尺寸照片</span>
          <van-uploader :before-read="onSelectAvatar" accept="image/*">
            <img src="../assets/btn_upload head portrait@2x.png" alt="" />
          </van-uploader>
        </div>
      </div>
    </div>
    <div class="editInfos-match-content">
      <van-cell title="姓名" class="editInfos-match-input">
        <template #default>
          <van-field
            v-model="name"
            :colon="true"
            input-align="right"
            readonly
          />
        </template>
      </van-cell>
      <van-cell
        title="部门"
        is-link
        class="editInfos-match-input"
        @click="handleInputForce('department')"
      >
        <template #default>
          <!-- <van-field
            v-model="department"
            :colon='true'
            input-align="right"
            @blur='departmentOk'
            placeholder="请输入部门"
          /> -->
          <span>{{ department }}</span>
        </template>
      </van-cell>
      <van-cell title="工号" class="editInfos-match-input">
        <template #default>
          <van-field
            v-model="employeeNo"
            :colon="true"
            input-align="right"
            readonly
          />
        </template>
      </van-cell>
      <van-cell title="工作区域" is-link class="editInfos-match-input">
        <template #default>
          <van-field
            v-model="workArea"
            :colon="true"
            input-align="right"
            placeholder="请输入工作区域"
            @click="showPicker = true"
            readonly
          />
        </template>
      </van-cell>
      <van-cell
        title="联系方式"
        is-link
        class="editInfos-match-input"
        @click="handleInputForce('contactNumber')"
      >
        <template #default>
          <!-- <van-field
            v-model="contactNumber"
            :colon='true'
            input-align="right"
            @blur='contactOk'
            placeholder="请输入联系方式"
          /> -->
          <span>{{ contactNumber }}</span>
        </template>
      </van-cell>
      <van-cell
        title="个人特长"
        is-link
        class="editInfos-match-input"
        @click="handleInputForce('personalStrength')"
      >
        <template #default>
          <!-- <van-field
            v-model="personalStrength"
            :colon='true'
            input-align="right"
            @blur='specialtyOk'
            placeholder="请输入个人特长"
          /> -->
          <span>{{ personalStrength }}</span>
        </template>
      </van-cell>
      <van-cell title="跟进数" class="editInfos-match-input">
        <template #default>
          <van-field
            v-model="followUpQuantity"
            :colon="true"
            input-align="right"
            readonly
          />
        </template>
      </van-cell>
      <van-cell title="积分" class="editInfos-match-input">
        <template #default>
          <van-field
            v-model="points"
            :colon="true"
            input-align="right"
            readonly
          />
        </template>
      </van-cell>
      <van-cell
        title="自我介绍"
        is-link
        class="editInfos-match-input"
        @click="handleInputForce('selfIntroduction')"
      >
        <template #default>
          <!-- <van-field
            v-model="selfIntroduction"
            :colon='true'
            input-align="right"
            @blur="oneselfOk"
            placeholder="请输入自我介绍"
          /> -->
          <span>{{ selfIntroduction }}</span>
        </template>
      </van-cell>
    </div>
    <van-popup v-model:show="showPicker" round position="bottom">
      <van-picker
        title=""
        :columns="workAreaColumns"
        @confirm="onConfirm"
        @cancel="onCancel"
        show-toolbar
      />
    </van-popup>
    <avatar-cropper
      :visible.sync="cropperVisible"
      :img-src="rawImgSrc"
        :fixedNumber="fixedNumber"
      @confirm="onCropConfirm"
      @cancel="onCropCancel"
    />
  </div>
</template>
<script>
import { Toast } from "vant";
import { ImagePreview } from "vant";
import { updateMatchmakerInfo } from "../api/matchmakerInfo";
import { upLoadImages } from "../api/user";
import defaultPhoto from "../assets/defaultPhoto.png";
import AvatarCropper from "../components/AvatarCropper.vue";
export default {
  components: { AvatarCropper },
  data() {
    return {
      ChineseCOMPANYNAME: process.env.ChineseCOMPANYNAME,
      COMPANYNAME: process.env.COMPANYNAME,
      TEL: process.env.TEL,
      avatarLink: "", //人物照片
      name: "",
      department: "",
      employeeNo: "",
      workArea: "",
      contactNumber: "",
      selfIntroduction: "",
      followUpQuantity: "",
      points: "",
      personalStrength: "",
      showPicker: false,
        fixedNumber: [1, 1], // 截图框比例
      cropperVisible: false,
      rawImgSrc: "",
      workAreaColumns: [
        { text: "W区", value: 1 },
        { text: "E区", value: 2 },
        { text: "M区", value: 3 },
        { text: "R区", value: 4 },
        { text: "无", value: 5 }
      ]
    };
  },
  computed: {
    isAtl2() {
      return this.COMPANYNAME == "ATL";
    }
  },
  methods: {
    // 预览头像大图
    previewAvatar() {
      if (this.avatarLink) {
        ImagePreview({
          images: [this.avatarLink],
          closeable: true,
          closeIconPosition: "top-right"
        });
      }
    },
    // 修改工作区
    onConfirm(obj) {
      this.showPicker = false;
      this.workArea = obj.text;
      updateMatchmakerInfo({
        ...this.$store.getters.baseInfo,
        workArea: obj.value
      }).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", res.data);
        }
      });
    },
    onCancel(value) {
      this.showPicker = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onSelectAvatar(file) {
        this.fixedNumber = [1, 1];
      const reader = new FileReader();
      reader.onload = e => {
        this.rawImgSrc = e.target.result;
        this.cropperVisible = true;
      };
      reader.readAsDataURL(file);
      return false;
    },
    onCropCancel() {
      this.rawImgSrc = "";
      this.cropperVisible = false;
    },
    async onCropConfirm(blob) {
      const formData = new FormData();
      formData.append("formFile", blob, "avatar.jpg");
      try {
        const uploadRes = await upLoadImages(formData);
        if (uploadRes.code !== 20000) {
          this.rawImgSrc = "";
          Toast({ message: "上传失败" });
          return;
        }
        const item = await updateMatchmakerInfo({
          ...this.$store.getters.baseInfo,
          avatarLink: uploadRes.data
        });
        if (item.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", item.data);
          this.avatarLink = item.data.avatarLink || uploadRes.data;
          this.rawImgSrc = "";
          this.cropperVisible = false;
          Toast({ message: "上传成功" });
        } else {
          this.rawImgSrc = "";
          Toast({ message: "上传失败" });
        }
      } catch (e) {
        this.rawImgSrc = "";
        Toast({ message: "上传失败" });
      }
    },
    // afterUploadPhoto (file){
    //   // 上传照片，替换掉原有的。
    //   this.photo=file.content
    // },
    // nameOk() {
    //   // this.$store.dispatch('UpdateBasicInfo')
    //   updateMatchmakerInfo({
    //     ...this.$store.getters.baseInfo,
    //     name: this.name,
    //   });
    // },
    departmentOk() {
      updateMatchmakerInfo({
        ...this.$store.getters.baseInfo,
        department: this.department
      }).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", res.data);
        }
      });
    },
    // employeeNoOk() {
    //   updateMatchmakerInfo({
    //     ...this.$store.getters.baseInfo,
    //     employeeNo: this.employeeNo,
    //   });
    // },
    workAreaOk() {},
    contactOk() {
      updateMatchmakerInfo({
        ...this.$store.getters.baseInfo,
        contactNumber: this.contactNumber
      }).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", res.data);
        }
      });
    },
    specialtyOk() {
      updateMatchmakerInfo({
        ...this.$store.getters.baseInfo,
        personalStrength: this.personalStrength
      }).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", res.data);
        }
      });
    },
    oneselfOk() {
      updateMatchmakerInfo({
        ...this.$store.getters.baseInfo,
        selfIntroduction: this.selfIntroduction
      }).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("UpdateBasicInfo", res.data);
        }
      });
    },
    // 跳转到红娘编辑页（带参数）
    handleInputForce(value) {
      this.$router.push({ path: `/editMatchFiled/${value}` });
    }
  },
  created() {
    if (!this.isAtl2) {
      this.workAreaColumns = [{ text: "东莞", value: 15 }];
    }
    const {
      name,
      department,
      employeeNo,
      workArea,
      contactNumber,
      selfIntroduction,
      followUpQuantity,
      personalStrength,
      avatarLink,
      points
    } = this.$store.getters.baseInfo;
    this.name = name;
    this.department = department;
    this.employeeNo = employeeNo;
    const selectedWorkArea = this.workAreaColumns.find(
      item => item.value == workArea
    );
    this.workArea = selectedWorkArea ? selectedWorkArea.text : "";

    this.contactNumber = contactNumber;
    this.selfIntroduction = selfIntroduction;
    this.followUpQuantity = followUpQuantity;
    this.personalStrength = personalStrength;
    this.avatarLink = avatarLink;
    this.points = points;
  }
};
</script>
<style lang="less" src="../style/matchMakerInfo.less" />



// WEBPACK FOOTER //
// src/views/matchMakerInfo.vue